import { ReactNode } from 'react'

import Image from 'next/image'
import { ReactMarkdown } from 'react-markdown/lib/react-markdown'
import rehypeRaw from 'rehype-raw'

import * as S from './styles'
import { Tag, Text } from '@/components'
import { Article } from '@/service/api/blog'

export type ContentContainerProps = {
  /**
   * Data of the article
   *
   * @example
   * ```tsx
   * <ContentContainer data={articleData} />
   * ```
   */
  data: Article
  /**
   * Tags of the article
   *
   * @example
   * ```tsx
   * <ContentContainer tags={['Tag 1', 'Tag 2']} />
   * ```
   *
   * @default []
   */
  tags?: string[]
}

type TagImg = {
  node: any
  children: ReactNode
}
const ImageComponent = ({ node, children }: TagImg) => {
  if (node.children[0].tagName === 'img') {
    const image: any = node.children[0]
    return (
      <div className="image">
        <Image src={image.properties.src} alt={image.properties.alt} fill />
      </div>
    )
  }

  return <p>{children}</p>
}
export const ContentContainer: React.FC<ContentContainerProps> = ({ data }) => (
  <S.ContentContainer>
    <Text size="h1" className="title" color="darkgray">
      {data.title}
    </Text>
    <S.TagContainer>
      {data.tags.map((tag) => (
        <Tag key={tag} label={tag} />
      ))}
    </S.TagContainer>

    <ReactMarkdown
      className="content"
      rehypePlugins={[rehypeRaw]}
      components={{
        p: ImageComponent,
      }}
    >
      {data.content}
    </ReactMarkdown>
  </S.ContentContainer>
)
